var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBacteriaIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.858,
    y1: 0.111,
    x2: 0.162,
    y2: 0.923,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bccff3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "red"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17018",
    "data-name": "Rectangle 17018",
    width: 15.281,
    height: 13.719,
    fill: "red"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11887",
    "data-name": "Group 11887",
    transform: "translate(-394 -152)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16859",
    "data-name": "Rectangle 16859",
    width: 36,
    height: 36,
    rx: 8,
    transform: "translate(394 152)",
    opacity: 0.2,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11886",
    "data-name": "Group 11886",
    transform: "translate(403.96 162.23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11885",
    "data-name": "Group 11885",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37944",
    "data-name": "Path 37944",
    d: "M7.628,13.718q-2.877,0-5.754,0A1.8,1.8,0,0,1,.028,12.209a1.827,1.827,0,0,1,.267-1.279Q1.993,8,3.685,5.064c.8-1.377,1.586-2.757,2.388-4.131a1.785,1.785,0,0,1,2.24-.8,1.854,1.854,0,0,1,.935.848q1.941,3.37,3.888,6.737c.628,1.088,1.262,2.173,1.883,3.266a1.789,1.789,0,0,1-.529,2.427,1.911,1.911,0,0,1-1.108.31H7.628m.008-.9c1.925,0,3.85,0,5.775,0a.9.9,0,0,0,.818-1.412q-2.876-4.99-5.76-9.975a.9.9,0,0,0-1.654.006Q3.933,6.423,1.058,11.414a1.091,1.091,0,0,0-.145.423.9.9,0,0,0,.971.982q2.876,0,5.751,0",
    transform: "translate(0 0)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37945",
    "data-name": "Path 37945",
    d: "M151.151,93.857h.857c.006.083.016.159.017.234,0,1.328,0,2.656,0,3.983,0,.19-.04.276-.249.258s-.409,0-.629,0Z",
    transform: "translate(-143.936 -89.377)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37946",
    "data-name": "Path 37946",
    d: "M148.242,207.413a.6.6,0,1,1,.615-.569.6.6,0,0,1-.615.569",
    transform: "translate(-140.618 -196.378)",
    fill: "red"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBacteriaIcon);
export default __webpack_public_path__ + "static/media/bacteriaIcon.4c9ffd353896f196c825807d26c3dd3e.svg";
export { ForwardRef as ReactComponent };